import { styled } from "@mui/material";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import Typography from "@mui/material/Typography";

export const ProfileSection = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 16,
  marginBottom: 16
});

export const AvatarWrapper = styled(Avatar)({
  width: 80,
  height: 80,
  border: "3px solid white",
  boxShadow: "0 2px 8px rgba(0,0,0,0.15)"
});

export const CompanyNameRow = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 12
});

export const CompanyName = styled(Typography)({
  fontWeight: 600,
  fontSize: "1.5rem"
});

export const IconWrapper = styled(Box)({
  display: "flex",
  alignItems: "center",
  gap: 8,
  marginBottom: 8
});

export const InfoLabel = styled("span")({
  fontWeight: 500,
  marginRight: 4
});

